<script>
export default {
  data() {
    return {
      opened: false
    };
  },

  methods: {
    open() {
      this.opened = true;
      this.$emit("modal-opened");
    },

    close() {
      this.opened = false;
      this.$emit("modal-closed");
    }
  }
};
</script>
